var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { TextField } from "@mui/material";
import { useField } from "@unform/core";
import { useEffect, useState } from "react";
export var VTextField = function (_a) {
    var name = _a.name, rest = __rest(_a, ["name"]);
    var _b = useField(name), fieldName = _b.fieldName, registerField = _b.registerField, defaultValue = _b.defaultValue, error = _b.error, clearError = _b.clearError;
    var _c = useState(defaultValue || ""), value = _c[0], setValue = _c[1];
    useEffect(function () {
        registerField({
            name: fieldName,
            getValue: function () { return value; },
            setValue: function (_, newValue) { return setValue(newValue); },
        });
    }, [registerField, fieldName, value]);
    var handleChange = function (e) {
        if (e.target.value.length > 11) {
            return;
        }
        var newValue = e.target.value.replace("-", "").toUpperCase();
        setValue(newValue);
    };
    return (_jsx(_Fragment, { children: _jsx(TextField, __assign({}, rest, { error: !!error, helperText: error, value: value, defaultValue: defaultValue, onKeyDown: function () { return (error ? clearError() : undefined); }, onChange: handleChange })) }));
};
